import { styled } from '@mui/system';

const Logo = styled('img')({
  height: 36,
});

export { Logo };
